export const SLIDE_STEP = 2;

const PRODUCT_CAROUSEL_PREFIX = "ProductCarouselBase";

export const PRODUCT_CAROUSEL_CLASSES = {
  header: `${PRODUCT_CAROUSEL_PREFIX}-header`,
  swiper: `${PRODUCT_CAROUSEL_PREFIX}-swiper`,
  element: `${PRODUCT_CAROUSEL_PREFIX}-element`,
  slider: `${PRODUCT_CAROUSEL_PREFIX}-slider`,
  container: `${PRODUCT_CAROUSEL_PREFIX}-container`,
  elements: `${PRODUCT_CAROUSEL_PREFIX}-elements`,
  buttons: `${PRODUCT_CAROUSEL_PREFIX}-buttons`,
  button: `${PRODUCT_CAROUSEL_PREFIX}-button`,
  buttonLeft: `${PRODUCT_CAROUSEL_PREFIX}-buttonLeft`,
  buttonRight: `${PRODUCT_CAROUSEL_PREFIX}-buttonRight`,
};
